import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  ReportRequestParams,
  TextResponse,
  extraFiltersOnly,
} from 'src/app/common/dtos/reports.dto';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import { EnvironmentService } from 'src/app/common/services/environment/environment.service';
import { DomElement } from 'src/app/common/utilities/dom-element';
import { ModalComponent } from '../../modals/modal/modal.component';

@Component({
  selector: 'app-proforms-attachment-response',
  standalone: false,

  templateUrl: './proforms-attachment-response.component.html',
  styleUrl: './proforms-attachment-response.component.scss',
})
export class ProformsAttachmentResponseComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input() requestParams: ReportRequestParams;

  @Input() questionTitle: string;

  @Input() fieldId: string;

  @ViewChild('responseModal') modal: ModalComponent;

  modalResponse = '';

  isLoading = true;

  params: ReportRequestParams[] = [];

  currentPage = 1;

  totalResponses = 0;

  responses: TextResponse[];

  downloadUrl: string;

  constructor(
    private apiService: APICoreService,
    private cdRef: ChangeDetectorRef,
    protected httpClient: HttpClient
  ) {}

  ngOnInit(): void {
    if (this.requestParams) {
      this.getResponses(this.requestParams);
    }
  }

  ngOnChanges(change: SimpleChanges) {
    if (
      change['requestParams'] &&
      change['requestParams'].firstChange === false
    ) {
      this.getResponses(this.requestParams);
    }
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }

  getResponses(params: ReportRequestParams) {
    this.isLoading = true;
    this.apiService
      .getRequest('reporting/load-report', {
        report: 'proformTextResponses',
        ...params,
        filters: extraFiltersOnly(params.filters, params.report_filterset_id),
      })
      .subscribe((response) => {
        this.totalResponses = response.totalCount;
        this.responses = response.items;
        this.isLoading = false;
      });
  }

  paginationChange() {
    const params = {
      ...this.requestParams,
      page: this.currentPage,
    };
    this.getResponses(params);
  }

  // eslint-disable-next-line class-methods-use-this
  viewFile(url: string) {
    window.open(EnvironmentService.apiUrl() + url, '_blank');
  }

  downloadFile(url: string) {
    this.httpClient
      .get(`${EnvironmentService.apiUrl()}${url}`, {
        responseType: 'blob',
      })
      .subscribe((blob) => {
        this.downloadUrl = window.URL.createObjectURL(blob);
        const link = DomElement.create(
          `a[href="${this.downloadUrl}"][download="${url}"]`
        );
        link.click();
        link.remove();
      });
  }
}
